import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation SurveyEnable($uid: String!){
        survey_enable (uid: $uid) {
            success
        }
    }
`;

export async function surveyEnable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ survey_enable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.survey_enable;
}
